module.exports = __webpack_public_path__ + "img/info.a7b3bb16.svg";